import React, { useState, useEffect, useContext } from "react";
import "../../css_files/Master/CurrencyMaster.css";
import Table from "../Homepage/Table";
import AddCurrencyMaster from "./AddCurrencyMaster";
import SearchCurrencyMaster from "./SearchCurrencyMaster";
import { toast, ToastContainer } from "react-toastify";
import getCookie from "../../api";
import axios from "axios";
import { triggerscroll } from "../Homepage/Homepage";
import AddMaster from "./AddMaster";
import SearchMaster from "./SearchMaster";
import Pagination from "../Homepage/Pagination";
import axiosInstance from "../../api";

function CurrencyMaster() {
  const [showaddform, setshowaddform] = useState(false);
  const [showsearchform, setshowsearchform] = useState(false);
  const tablehead = [
    "Currency Code",
    "Currency Name",
    "Rate",
    "Description",
  ];
  const [tabledata, setTableData] = useState([]);
  const [reload, setReload] = useState(false);
  const [triggerupdate, settriggerupdate] = useState(false);
  const [currencyupdatedata, setcurrencyupdatedata] = useState(null);
  const [datareload, setdatareload] = useState(0);
  const [loading, setloading] = useState(false);
  const { setExpiredSession, permissionsdata, userData } =
    useContext(triggerscroll);
  const [filterbutton, setfilterbutton] = useState(false);
  const [activatedfilters, setactivatedfilters] = useState([]);
  const [pagenumber, setpagenumber] = useState(1);
  const [pagecount, setpagecount] = useState(0);
  const [excelloading, setexcelloading] = useState(false);
  const [totalcount, setTotalCount] = useState(0);
  const [search, setSearch] = useState("");

  function fetchcurrencydata(currencyId) {
    setcurrencyupdatedata(null);
    const url = `${process.env.REACT_APP_API_URL}/api/v1/Currency/GetSingleCurrency?code=${currencyId}`;
    axiosInstance
      .get(url)
      .then((res) => {
        setcurrencyupdatedata(res.data);
      })
      .catch(console.log);
  }

  useEffect(() => {
    setTableData([]);
    setloading(true);
    const URL = `${process.env.REACT_APP_API_URL}/api/v1/Currency/${pagenumber}`;
    axiosInstance
      .post(URL, {
        Search: search,
      })
      .then((response) => {
        setpagecount(response.data.count);
        setTotalCount(response.data.dataCount);
        setTableData(
          response.data.data.map((x) => [
            x.code,
            x.currencyName,
            x.rate,
            x.description,
          ])
        );
      })
      .catch(console.log)
      .finally(() => {
        setloading(false);
      });
  }, [reload, pagenumber]);

  function readPermission() {
    if (userData.role === "Administrator") return true;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" && x.subHead === "Currency" && x.isRead === true
    );
    return issatisfied;
  }

  function writePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" && x.subHead === "Currency" && x.isWrite === true
    );
    return !issatisfied;
  }

  function updatePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" && x.subHead === "Currency" && x.isUpdate === true
    );
    return !issatisfied;
  }

  function deletePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" && x.subHead === "Currency" && x.isDelete === true
    );
    return !issatisfied;
  }

  return (
    <section className="currency-master">
      <h1>Currency Master</h1>
      <blockquote className="currency-master-forms">
        <AddMaster
          text="Add Currency Master"
          setshowaddform={setshowaddform}
          settriggerupdate={settriggerupdate}
          setshowsearchform={setshowsearchform}
          permit={writePermission}
        />

        <SearchMaster
          text="Search Currency Master"
          setshowsearchform={setshowsearchform}
          setshowaddform={setshowaddform}
        />
      </blockquote>
      {showaddform && (
        <AddCurrencyMaster
          setshowaddform={setshowaddform}
          reload={reload}
          setReload={setReload}
          triggerupdate={triggerupdate}
          currencyupdatedata={currencyupdatedata}
          key={`${currencyupdatedata?.code}-${triggerupdate}-${datareload}`}
        />
      )}
      {showsearchform && (
        <SearchCurrencyMaster
          setshowsearchform={setshowsearchform}
          setpagenumber={setpagenumber}
          setReload={setReload}
          setSearch={setSearch}
          reload={reload}
        />
      )}
      <Table
        tablehead={tablehead}
        tabledata={tabledata}
        setshowaddform={setshowaddform}
        settriggerupdate={settriggerupdate}
        fetchdata={fetchcurrencydata}
        url="Currency/UpdateCurrency"
        reload={reload}
        setReload={setReload}
        setdatareload={setdatareload}
        datareload={datareload}
        loading={loading}
        readPermission={readPermission}
        updatePermission={updatePermission}
        deletePermission={deletePermission}
        totalcount={totalcount}
      />
      <Pagination
        count={pagecount}
        setpagenumber={setpagenumber}
        pagenumber={pagenumber}
      />
    </section>
  );
}

export default CurrencyMaster;
